// KK (Kalite Kontrol) API wrapper'ları — spec §4. Backend route'ları için
// apps/backend/src/routes/qc.ts. Hata gövdesi { error: code } ApiError.message'a düşer.

import type { QcPromptCreate, QcPromptDto, QcPromptUpdate } from "@mahir/shared";
import { api } from "./client";

// Danışman dropdown'ı — KK koşabilen roller görür, sadece aktif promptlar.
export async function fetchQcPrompts(): Promise<{ prompts: QcPromptDto[] }> {
  return api<{ prompts: QcPromptDto[] }>("/qc-prompts");
}

// KK başlat (atomik claim + enqueue) — 202 Accepted.
export async function startQc(
  projectId: string,
  code: string,
  qcPromptId: string,
): Promise<{ version: number }> {
  return api<{ version: number }>(`/projects/${projectId}/sections/${code}/qc`, {
    method: "POST",
    body: { qcPromptId },
  });
}

// Rewrite adayını kabul et.
export async function acceptQc(projectId: string, code: string): Promise<{ ok: true }> {
  return api<{ ok: true }>(`/projects/${projectId}/sections/${code}/qc/accept`, {
    method: "POST",
    body: {},
  });
}

// Reddet (CritiquePanel'de "Kapat").
export async function rejectQc(
  projectId: string,
  code: string,
  reason?: string,
): Promise<{ ok: true }> {
  return api<{ ok: true }>(`/projects/${projectId}/sections/${code}/qc/reject`, {
    method: "POST",
    body: reason ? { reason } : {},
  });
}

// ---- Admin CRUD — qc_prompts.manage (AdminPromptLibrary) ----
export async function adminListQcPrompts(): Promise<{ prompts: QcPromptDto[] }> {
  return api<{ prompts: QcPromptDto[] }>("/admin/qc-prompts");
}

export async function adminCreateQcPrompt(input: QcPromptCreate): Promise<{ prompt: QcPromptDto }> {
  return api<{ prompt: QcPromptDto }>("/admin/qc-prompts", { method: "POST", body: input });
}

export async function adminUpdateQcPrompt(
  id: string,
  input: QcPromptUpdate,
): Promise<{ prompt: QcPromptDto }> {
  return api<{ prompt: QcPromptDto }>(`/admin/qc-prompts/${id}`, {
    method: "PATCH",
    body: input,
  });
}

export async function adminDeleteQcPrompt(id: string): Promise<void> {
  await api(`/admin/qc-prompts/${id}`, { method: "DELETE" });
}
